import { SET_EDIT_KIOSK_DATA } from '../actions/kioskActions';

const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_EDIT_KIOSK_DATA:
      return action.kiosk;
    default:
      return state;
  }
}
